/**
 * Main Dealspotng categories (order 1–15).
 */
export const mainCategories = [
  { id: 'cars', name: 'Cars', icon: 'car', subcategories: [], order: 1 },
  {
    id: 'bikes',
    name: 'Bikes',
    icon: 'motorcycle',
    subcategories: ['Motorcycles', 'Scooters', 'Bicycles', 'Spare Parts'],
    order: 2,
  },
  {
    id: 'properties',
    name: 'Properties',
    icon: 'house',
    subcategories: [
      'For Sale: Houses & Apartments',
      'For Rent: Houses & Apartments',
      'Lands & Plots',
      'New Projects',
      'For Rent: Shops & Offices',
      'For Sale: Shops & Offices',
      'PG & Guest Houses',
    ],
    order: 3,
  },
  {
    id: 'electronics-appliances',
    name: 'Electronics & Appliances',
    icon: 'electronics',
    subcategories: [
      'TVs, Video - Audio',
      'Kitchen & Other Appliances',
      'Computers & Laptops',
      'Cameras & Lenses',
      'Games & Entertainment',
      'Fridges',
      'Computer Accessories',
      'ACs',
      'Washing Machines',
    ],
    order: 4,
  },
  {
    id: 'mobiles',
    name: 'Mobiles',
    icon: 'mobile',
    subcategories: ['Mobile Phones', 'Accessories', 'Tablets'],
    order: 5,
  },
  {
    id: 'commercial-vehicles-spares',
    name: 'Commercial Vehicles & Spares',
    icon: 'truck',
    subcategories: ['Commercial & Other Vehicles', 'Spare Parts'],
    order: 6,
  },
  {
    id: 'jobs',
    name: 'Jobs',
    icon: 'jobs',
    subcategories: [
      'Data entry & Back office',
      'Sales & Marketing',
      'BPO & Telecaller',
      'Driver',
      'Office Assistant',
      'Teacher',
      'Cook',
      'IT Engineer & Developer',
      'Hotel & Travel Executive',
      'Other Jobs',
    ],
    order: 7,
  },
  {
    id: 'furniture',
    name: 'Furniture',
    icon: 'house',
    subcategories: [
      'Sofa & Dining',
      'Beds & Wardrobes',
      'Home Decor & Garden',
      'Kids Furniture',
      'Other Household Items',
    ],
    order: 8,
  },
  {
    id: 'fashion',
    name: 'Fashion',
    icon: 'house',
    subcategories: ['Men', 'Women', 'Kids'],
    order: 9,
  },
  {
    id: 'pets',
    name: 'Pets',
    icon: 'house',
    subcategories: [
      'Dogs',
      'Fishes & Aquarium',
      'Pet Food & Accessories',
      'Other Pets',
    ],
    order: 10,
  },
  {
    id: 'books-sports-hobbies',
    name: 'Books, Sports & Hobbies',
    icon: 'house',
    subcategories: [
      'Books',
      'Gym & Fitness',
      'Musical Instruments',
      'Sports Equipment',
      'Other Hobbies',
    ],
    order: 11,
  },
  {
    id: 'services',
    name: 'Services',
    icon: 'truck',
    subcategories: [
      'Education & Classes',
      'Tours & Travel',
      'Electronics Repair & Services',
      'Health & Beauty',
      'Home Renovation & Repair',
      'Other Services',
    ],
    order: 12,
  },
  {
    id: 'kids',
    name: 'Kids',
    icon: 'house',
    subcategories: [
      'Toys & Games',
      'Baby Clothing',
      'Strollers & Carriers',
      'School Supplies',
      'Kids Accessories',
    ],
    order: 13,
  },
  {
    id: 'tools-machinery',
    name: 'Tools & Machinery',
    icon: 'truck',
    subcategories: [
      'Power Tools',
      'Hand Tools',
      'Industrial Machinery',
      'Garden Equipment',
      'Other Tools',
    ],
    order: 14,
  },
  {
    id: 'music-instruments',
    name: 'Music & Instruments',
    icon: 'house',
    subcategories: [
      'Guitars',
      'Keyboards & Pianos',
      'Drums & Percussion',
      'Wind Instruments',
      'DJ & Studio Equipment',
      'Other Instruments',
    ],
    order: 15,
  },
];
